import { render, staticRenderFns } from "./ButtonImage.vue?vue&type=template&id=0a7a74e6&"
import script from "./ButtonImage.vue?vue&type=script&lang=js&"
export * from "./ButtonImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports